import { createFeatureSelector, createSelector } from '@ngrx/store';
import { mapDriverManagementDriversToVehicleDrivers } from './driver-management-drivers.models';
import { DriverManagementDriversState } from './driver-management-drivers.reducer';

export const selectDriverManagementDriversState =
  createFeatureSelector<DriverManagementDriversState>('driverManagementDrivers');

export const selectDriverManagementDriversResponseByKey = (key: string) =>
  createSelector(selectDriverManagementDriversState, (state) => state.cache[key] ?? null);

export const selectDriverManagementDriversByKey = (key: string) =>
  createSelector(selectDriverManagementDriversResponseByKey(key), (response) => response?.drivers ?? []);

export const selectDriverManagementDriverOptionsByKey = (key: string) =>
  createSelector(selectDriverManagementDriversResponseByKey(key), (response) =>
    mapDriverManagementDriversToVehicleDrivers(response),
  );

export const selectDriverManagementDriversLoadedByKey = (key: string) =>
  createSelector(selectDriverManagementDriversState, (state) => key in state.cache);

export const selectDriverManagementDriversLoadingByKey = (key: string) =>
  createSelector(selectDriverManagementDriversState, (state) => !!state.loading[key]);

export const selectDriverManagementDriversErrorByKey = (key: string) =>
  createSelector(selectDriverManagementDriversState, (state) => (key in state.error ? state.error[key] : null));
